import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 160px 24px;
  max-width: 1300px;
  margin: 0 auto;
  position: relative;
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 120px;
`;

export const CaseLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.3em;
  margin-bottom: 24px;
`;

export const MainTitle = styled.h2`
  font-family: 'Playfair Display', serif;
  font-size: 82px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 1;
  
  span {
    font-family: 'Dancing Script', cursive;
    color: #CC66FF;
    font-size: 100px;
    margin-left: 10px;
  }

  @media (max-width: 768px) {
    font-size: 48px;
    span { font-size: 56px; }
  }
`;

export const TileGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 160px;
`;

export const CaseStudyWrapper = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 80px;
  align-items: center;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

export const VisualPanel = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 4/3;
  background: ${({ bgColor }) => bgColor || '#2D5BFF'};
  border-radius: 20px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);

  &:hover {
    transform: translateY(-10px);
  }
`;

export const VisualTitle = styled.div`
  font-size: 28px;
  font-weight: 600;
  color: #FFFFFF;
  max-width: 80%;
  line-height: 1.4;
`;

export const Screenshot = styled.img`
  width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.3);
  margin-top: auto;
  transform: translateY(20px);
`;

export const InfoPanel = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ProjectName = styled.h3`
  font-size: 32px;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 12px;

  &::before {
    content: '';
    width: 20px;
    height: 2px;
    background: #444;
  }
`;

export const ProjectDesc = styled.p`
  font-size: 18px;
  color: #888;
  line-height: 1.6;
  margin-bottom: 32px;
`;

export const BulletList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 40px;
`;

export const Bullet = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 15px;
  color: #AAA;
  line-height: 1.5;

  svg {
    color: #5588FF;
    flex-shrink: 0;
    margin-top: 4px;
  }
`;

export const TagCloud = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const Tag = styled.div`
  padding: 6px 14px;
  background: #111;
  border: 1px solid #222;
  border-radius: 50px;
  font-size: 11px;
  font-weight: 700;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;
